import { AnyObject } from "global";
import ContextType from "shared/enums/ContextType";
import InventoryType from "shared/enums/InventoryType";
import { ParticipantRole } from "shared/enums/ParticipantRole";
import ParticipantSubRole from "shared/enums/ParticipantSubRole";
import { ProgramParticipantTag } from "shared/enums/ProgramParticipantTag";
import { ProgramType } from "shared/enums/ProgramType";
import I18n from "shared/types/I18n";
import RateCardQuantityType from "../../shared/enums/RateCardQuantityType";
import FieldOption from "../../shared/form/renderer/types/FieldOption";
import SelectableType from "shared/enums/SelectableType";
import FieldEntityType from "shared/form/renderer/enums/EntityType";
import FieldRenderType from "shared/form/renderer/enums/FieldRenderType";
import VendorIdentifier from "shared/enums/vendor/VendorIdentifier";
import FeaturedListCardTemplateType from "../../shared/enums/FeaturedListCardTemplateType";
import RegistrationWorkflowType from "shared/enums/RegistrationWorkflowType";
import TransactionMethodType from "shared/enums/TransactionMethodType";
import ApiVendorSpecificData, { ConfigMeta } from "shared/types/vendor/ApiVendorSpecificData";
import VendorAuthenticationType from "shared/enums/vendor/VendorAuthenticationType";
import VendorAdvanceMetaType from "shared/enums/vendor/VendorAdvanceMetaType";
import ProgramProfileWorkflowType from "shared/enums/ProgramProfileWorkflowType";
import InventoryWorkflowType from "../../shared/enums/InventoryWorkflowType";
import { CriteriaConfigType } from "../../shared/enums/CriteriaConfigType";
import AssociatedProgramActivityDefaultShortlistPriority from "../../shared/enums/AssociatedProgramActivityDefaultShortlistPriority";
import ContextEntityType from "shared/enums/ContextEntityType";
import FormType from "shared/enums/FormType";
import MutualMatchInterestLevel from "shared/enums/MutualMatchInterestLevel";
import MutualMatchRequestInitiator from "shared/enums/MutualMatchRequestInitiator";
import InventorySubType from "../../shared/enums/InventorySubType";

/**
 *  Static data response types generated from JSON
 */

export interface PlatformConstants {
  country?: AnyObject;
  participantRole?: AnyObject;
  participantSubRole: AnyObject;
  languageType?: AnyObject;
  currencyCode?: AnyObject;
  registrationState?: AnyObject;
  paymentGatewayType?: AnyObject;
  theme?: AnyObject;
  timezone?: AnyObject;
  timezoneDisplayStr?: AnyObject;
  rateCardQuantityType?: AnyObject;
  rateCardDiscountType?: AnyObject;
  ticketStatus?: AnyObject;
  registrationStatus?: AnyObject;
  consoleUserType?: AnyObject;
  inventoryType: AnyObject;
  supportedRegistrationPlatformType: AnyObject;
  registrationWorkflowType: AnyObject;
  organizationStatus: AnyObject;
  adminRegistrationActionType: AnyObject;
  programType: AnyObject;
  schemaFieldDisplayType: AnyObject;
  schemaFieldRenderType: AnyObject;
  schemaFieldEntityType: AnyObject;
  schemaFieldType: AnyObject;
  nonAttendeeApplicationStatus: AnyObject;
  commonDashboardActionType: AnyObject;
  timelineDashboardActionType: AnyObject;
  activityStatus: AnyObject;
  activityAction: AnyObject;
  programParticipantTag: AnyObject;
  ticketTransferStatus: AnyObject;
  allSchemaFieldRenderType: AnyObject;
  languageTypeLocaleId: AnyObject;
  purchaseOrderStatus: AnyObject;
  fieldOptionViewType: AnyObject;
  transactionStatus: AnyObject;
  inPersonMeetupProgramStatus: AnyObject;
  meetupProgramStatus: AnyObject;
  tabletalkProgramStatus: AnyObject;
  virtualTabletalkProgramStatus: AnyObject;
  buyersProgramStatus: AnyObject;
  tradeProgramStatus: AnyObject;
  stateStatus: AnyObject;
  eventState: AnyObject;
  selectableType: AnyObject;
  transactionType: AnyObject;
  adminAgendaMemberProfileActionType: Record<string, string>;
  prefix: AnyObject;
  profileStatus: AnyObject;
  adminProfileActionType: AnyObject;
  emailPhaseType: AnyObject;
  selectionAvailabilityTypesOption: AnyObject;
  selectionInterestLevel: AnyObject;
  selectionMatchCriteriaTypeOptions: AnyObject;
  selectableTypeForFSL: AnyObject;
  contextEntityType: AnyObject;
  utilityDataModules: AnyObject;
  searchFetchType: AnyObject;
  trackingType: AnyObject;
  eventAgendaMetaType: AnyObject;
  eventAgendaType: AnyObject;
  eventAgendaStatus: AnyObject;
  chatBotVendorType: AnyObject;
  programAgendaStatus: AnyObject;
  selectionType: AnyObject;
  programAgendaSubType: AnyObject;
  meetingUniqueness: AnyObject;
  participationStatus: AnyObject;
  programParticipationRole: AnyObject;
  reimbursementOption: AnyObject;
  feedbackFormType: AnyObject;
  interestLevelConfigurationType: AnyObject;
  reimbursementStatus: AnyObject;
  eventAgendaGroup: AnyObject;
  participationLocationType: AnyObject;
  associatedProgramStatus: AnyObject;
  selectionFeaturedListType: AnyObject;
  associatedProgramActivityType: AnyObject;
  associatedProgramActivityStatus: AnyObject;
  associatedProgramActivityEligibilityCriteriaType: AnyObject;
  selectionCardTemplateType: AnyObject;
  programParticipantType: AnyObject;
  handPickingSearchFetchType: AnyObject;
  meetingRepAckStatus: AnyObject;
  activitySelectionInterestLevel: AnyObject;
  activitySelectionStatus: AnyObject;
  supportedProgramType: AnyObject;
  connectionsProgramStatus: AnyObject;
  notificationAgendaGroupingType: AnyObject;
  exhibitorFeatureListRequestType: AnyObject;
  cookieManager: AnyObject;
  timeSlotAvailabilityType: AnyObject;
  dietaryRequirements: AnyObject;
  activityProgramParticipationInvitationStatus: AnyObject;
  badgeScanType: AnyObject;
  booleanFilterOption: AnyObject;
  regParticipantFilters: AnyObject;
  contactListType: AnyObject;
  transactionMethodType: AnyObject;
  vendorIdentifier: AnyObject;
  integrationEntityType: AnyObject;
  vendorAuthenticationType: AnyObject;
  vendorEntityType: AnyObject;
  vendorAdvanceMetaType: AnyObject;
  contactContextLocation: AnyObject;
  contactMode: AnyObject;
  programProfileWorkflowType: Array<ProgramProfileWorkflowType>;
  queueTaskType: AnyObject;
  queueTransactionLogStatus: AnyObject;
  exhibitorProfileStatus: AnyObject;
  adminEventOrganizationExhibitorProfileActionType: AnyObject;
  accessControlPolicy: AnyObject;
  mobileNotificationEligibilityCriteriaType: AnyObject;
  adminNotificationMessageStatus: AnyObject;
  showFilterOption: AnyObject;
  associatedProgramActivityDefaultShortlistPriority: {
    [key in AssociatedProgramActivityDefaultShortlistPriority]: string;
  };
  exclusiveAssociatedActivityPriorities: Array<AssociatedProgramActivityDefaultShortlistPriority>;
  nonExclusiveAssociatedActivityPriorities: Array<AssociatedProgramActivityDefaultShortlistPriority>;
  inventoryWorkflowType: { [key in InventoryWorkflowType]: string };
  customEventActionRedirectionType: AnyObject;
  customEventActionAssetType: AnyObject;
  customEventActionSupportType: AnyObject;
  platformQueryTemplateType: AnyObject;
  mutualMatchInterestLevel: Array<MutualMatchInterestLevel>;
  mutualMatchRequestInitiator: Array<MutualMatchRequestInitiator>;
  inventorySubType: { [key in InventorySubType]: string };
  platformQueryTemplateType: AnyObject;
}

export interface registrationConstants {}

export interface StaticOptions {
  country: Array<FieldOption>;
  jobLevel: Array<FieldOption>;
  prefix: Array<FieldOption>;
  timezone: Array<FieldOption>;
  languageType: Array<FieldOption>;
  dietaryRequirements: Array<FieldOption>;
}

export interface StaticDataResponseObject {
  platformConstants: PlatformConstants;
  staticOptions: StaticOptions;
  registrationConstants?: registrationConstants;
  localI18nMessages: I18n;
  roleAndRegistrationWorkflowTypeCombinationForRegForm: AnyObject;
  roleAndSubRoleCombinationForRegForm: AnyObject;
  inventoryTypeRateCardQuantityTypeMap: { [key: string]: Array<RateCardQuantityType> };
  showOnTicketsPageRoles: Array<ParticipantRole>;
  divisionApplicableRoles: Array<ParticipantRole>;
  eligibleForTicketsPage: Array<ParticipantSubRole>;
  applicableRegistrationTransitionState: AnyObject;
  singleAssignmentInventoryTypes: Array<InventoryType>;
  couponCodeSupportedInventoryType: Array<InventoryType>;
  inventoryTypeContextTypeMap: { [key in InventoryType]: ContextType };
  additionalChargeInventoryTypes: Array<InventoryType>;
  rateCardInventoryTypes: Array<InventoryType>;
  programTypeApplicableTagMap: Record<ProgramType, Array<ProgramParticipantTag>>;
  mandatoryProgramParticipantTagMapping: Record<ProgramType, Record<ParticipantSubRole, ProgramParticipantTag>>;
  selectableTypeToTemplateTypeMap: Record<SelectableType, Array<FeaturedListCardTemplateType>>;
  ptSeparator: string;
  restrictedRenderTypeForEntity: AnyObject;
  restrictedRenderTypeForForm: AnyObject;
  supportedEntityTypesForForm: AnyObject;
  programTypeToSelectableTypeMap: Record<ProgramType, Array<SelectableType>>;
  defaultFSLConfigurableForProgramTypes: Array<ProgramType>;
  searchableFieldEntityTypes: Array<FieldEntityType>;
  searchableFieldRenderTypes: Array<FieldRenderType>;
  programTypeDefaultHeaderImageMap: { [key in ProgramType]: string };
  noRateCardNeededWorkflowTypes: Array<RegistrationWorkflowType>;
  canHaveSponsorOrganizationsWorkflowTypes: Array<RegistrationWorkflowType>;
  shouldSelectRateCardWorkflowTypes: Array<RegistrationWorkflowType>;
  hasNoMaxRegistrationsLimitWorkflowTypes: Array<RegistrationWorkflowType>;
  selectableTransactionMethodTypes: Array<TransactionMethodType>;
  vendorSpecificDataMap: { [key in VendorIdentifier]: ApiVendorSpecificData };
  vendorAuthenticationTypes: { [key in VendorAuthenticationType]: Array<ConfigMeta> };
  externalFieldRenderTypes: Array<FieldRenderType>;
  vendorAdvanceMetaTypes: Array<VendorAdvanceMetaType>;
  tabletalkProfileFormFieldExclusionMap: Array<string, string>;
  inventoryTypeVsWorkflowType: { [key in InventoryType]: Array<InventoryWorkflowType> };
  criteriaConfigTypeVsInventoryTypeMap: { [key in InventoryType]: CriteriaConfigType };
  hideSponsorOrganizationsParticipantRoles: Array<ParticipantRole>;
  exclusiveAssociatedActivityPriorities: Array<AssociatedProgramActivityDefaultShortlistPriority>;
  nonExclusiveAssociatedActivityPriorities: Array<AssociatedProgramActivityDefaultShortlistPriority>;
  customEventActionDefaultIconImage: string;
  bulkUploadSupportedEntities?: Array<ContextEntityType>;
  supportedFormForContextType?: { [key in ContextEntityType]: FormType };
}

/**
 *  useStaticData hook response object.
 */
interface StaticDataObject extends PlatformConstants, registrationConstants {
  refetchStaticData: (key: string) => void;
  copies: I18n;
  roleAndRegistrationWorkflowTypeCombinationForRegForm: AnyObject;
  roleAndSubRoleCombinationForRegForm: AnyObject;
  inventoryTypeRateCardQuantityTypeMap: { [key: string]: Array<RateCardQuantityType> };
  staticOptions: StaticOptions;
  showOnTicketsPageRoles: Array<ParticipantRole>;
  divisionApplicableRoles: Array<ParticipantRole>;
  eligibleForTicketsPage: Array<ParticipantSubRole>;
  applicableRegistrationTransitionState: AnyObject;
  singleAssignmentInventoryTypes: Array<InventoryType>;
  couponCodeSupportedInventoryType: Array<InventoryType>;
  inventoryTypeContextTypeMap: { [key in InventoryType]: ContextType };
  additionalChargeInventoryTypes: Array<InventoryType>;
  rateCardInventoryTypes: Array<InventoryType>;
  programTypeApplicableTagMap: Record<ProgramType, Array<ProgramParticipantTag>>;
  mandatoryProgramParticipantTagMapping: Record<ProgramType, Record<ParticipantSubRole, ProgramParticipantTag>>;
  separator: { ptSeparator: string };
  restrictedRenderTypeForEntity: AnyObject;
  restrictedRenderTypeForForm: AnyObject;
  supportedEntityTypesForForm: AnyObject;
  selectableTypeToTemplateTypeMap: Record<SelectableType, Array<FeaturedListCardTemplateType>>;
  programTypeToSelectableTypeMap: Record<ProgramType, Array<SelectableType>>;
  defaultFSLConfigurableForProgramTypes: Array<ProgramType>;
  searchableFieldEntityTypes: Array<FieldEntityType>;
  searchableFieldRenderTypes: Array<FieldRenderType>;
  programTypeDefaultHeaderImageMap: { [key in ProgramType]: string };
  noRateCardNeededWorkflowTypes: Array<RegistrationWorkflowType>;
  canHaveSponsorOrganizationsWorkflowTypes: Array<RegistrationWorkflowType>;
  shouldSelectRateCardWorkflowTypes: Array<RegistrationWorkflowType>;
  hasNoMaxRegistrationsLimitWorkflowTypes: Array<RegistrationWorkflowType>;
  selectableTransactionMethodTypes: Array<TransactionMethodType>;
  vendorSpecificDataMap: { [key in VendorIdentifier]: ApiVendorSpecificData };
  vendorAuthenticationTypes: { [key in VendorAuthenticationType]: Array<ConfigMeta> };
  externalFieldRenderTypes: Array<FieldRenderType>;
  vendorAdvanceMetaTypes: Array<VendorAdvanceMetaType>;
  tabletalkProfileFormFieldExclusionMap: Array<string, string>;
  inventoryTypeVsWorkflowType: { [key in InventoryType]: Array<InventoryWorkflowType> };
  criteriaConfigTypeVsInventoryTypeMap: { [key in InventoryType]: CriteriaConfigType };
  hideSponsorOrganizationsParticipantRoles: Array<ParticipantRole>;
  customEventActionDefaultIconImage: string;
  bulkUploadSupportedEntities?: Array<ContextEntityType>;
  supportedFormForContextType?: { [key in ContextEntityType]: FormType };
}

interface StaticDataProviderProps extends React.PropsWithChildren<{}> {
  localeId?: string;
}

export enum StaticDataAction {
  CHANGE_LANGUAGE_TYPE = "CHANGE_LANGUAGE_TYPE"
}

interface StaticDataState {
  localeId?: string;
}

type StaticDataActionType = { type: Action.CHANGE_LANGUAGE_TYPE; payload: string };

interface StaticDataDispatchInterface {
  changeLanguageType: (payload: string) => void;
}

interface StaticDataQueryParams {
  regKey?: string;
}
